import { createAction, createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CreateOrganizationBillingProps, LoadOrganizationBillingProps, ReduxOrganizationBillingAddEditState, UpdateOrganizationBillingProps } from '../types';
import { ISelectItem, ReduxSliceState } from '../../../shared/types';
import { withPayloadType } from '../../../shared/utils';
import { ReduxRootState } from '../../../shared/redux/store';
import { OrganizationBilling, UserGroup } from '../../../api/types';

const initialState: ReduxOrganizationBillingAddEditState = {
    state: 'BUSY',
    organizationbilling: undefined,
};

export const createOrganizationBilling = createAction('organizationbilling/add-edit/createOrganizationBilling', withPayloadType<CreateOrganizationBillingProps>());
export const loadOrganizationBilling = createAction('organizationbilling/add-edit/loadOrganizationBilling', withPayloadType<LoadOrganizationBillingProps>());

const organizationBillingAddEditSlice = createSlice({
    name: 'organizationbilling/add-edit',
    initialState,
    reducers: {
        setState: (state, action: PayloadAction<ReduxSliceState>) => {
            state.state = action.payload;
        },
        setOrganizationBilling: (state, action: PayloadAction<OrganizationBilling | undefined>) => {
            state.organizationbilling = action.payload;
        },
    }
});


export default organizationBillingAddEditSlice;

const selectSelf = (state: ReduxRootState) => state.organizationBillingAddEdit;
export const selectOrganizationBillingAddEditState = createSelector(selectSelf, self => self.state);
export const selectOrganizationBillingAddEditIsBusy = createSelector(selectOrganizationBillingAddEditState, state => state === 'BUSY');
export const selectOrganizationBilling = createSelector(selectSelf, self => self.organizationbilling);
